import 'angular';
import 'angular-resource';
import { pluckData } from '../../../../utilities/request_transformers';

const dependencies = ['ngResource'];
const api_current_user_path = '/api/public/current_user';

angular.module('recruiterSearch.models.loggedSearch', dependencies)
  .factory('LoggedSearch', ['$resource',
    function($resource) {
      return $resource(
        `${api_current_user_path}/logged_searches/:id`,
        {},
        {
          query: {
            method: 'GET',
            isArray: true,
            transformResponse: [
              angular.fromJson,
              pluckData
            ]
          }
        }
      );
    }
  ]);
